import _get from 'lodash/get';

interface MakerItem {
  makerId: number;
  makerName: string;
}

interface ManagerItem {
  managerId: number;
  managerName: string;
}

interface CompaniesSuppliersListItem {
  id: string | number;
  srno: number;
  shortName: string;
  supplier: string;
  makers: MakerItem[];
  managers: ManagerItem[];
  makersIds: number[];
  managerIds: number[];
  status: string;
  actions: string;
  companyId?: number | string;
}

interface CompaniesSuppliersApiParser {
  CompaniesSuppliersListParser: (_res: any) => CompaniesSuppliersListItem[];
  MakersBySupplierListParser: (_res: any) => MakersBySupplierItem[];
  ManagersBySupplierListParser: (_res: any) => ManagersBySupplierItem[];
}

const companiesSuppliersApiParser: CompaniesSuppliersApiParser = {
  CompaniesSuppliersListParser: (_res: unknown): CompaniesSuppliersListItem[] => {
    const content = _get(_res, 'data.content', []) as any[];

    if (Array.isArray(content) && content.length > 0) {
      return content.map((itm, idx) => {
        const makersArr = Array.isArray(_get(itm, 'makers', [])) ? _get(itm, 'makers', []) : [];
        const managersArr = Array.isArray(_get(itm, 'managers', []))
          ? _get(itm, 'managers', [])
          : [];

        return {
          id: _get(itm, 'supplierId', 0),
          srno: Number(_get(itm, 'supplierId', idx + 1)),
          shortName: _get(itm, 'shortName', ''),
          supplier: _get(itm, 'companyName', ''),
          makers: makersArr.map((m: any) => ({
            makerId: Number(_get(m, 'makerId', 0)),
            makerName: String(_get(m, 'makerName', '')),
          })),
          managers: managersArr.map((m: any) => ({
            managerId: Number(_get(m, 'managerId', 0)),
            managerName: String(_get(m, 'managerName', '')),
          })),
          makersIds: makersArr.map((m: any) => Number(_get(m, 'makerId', 0))),
          managerIds: managersArr.map((m: any) => Number(_get(m, 'managerId', 0))),
          status: _get(itm, 'active', false) ? 'Active' : 'Inactive',
          actions: 'Edit',
          companyId: _get(itm, 'companyId', undefined),
        };
      });
    }

    return [];
  },
  MakersBySupplierListParser: (_res: unknown): MakersBySupplierItem[] => {
    const items = _get(_res, 'data', []) as any[];
    if (!Array.isArray(items)) return [];

    return items.map((itm) => ({
      supplierId: _get(itm, 'supplierId', 0),
      supplierName: _get(itm, 'supplierName', ''),
      makerId: _get(itm, 'makerId', 0),
      makerName: _get(itm, 'makerName', ''),
      active: Boolean(_get(itm, 'active', false)),
    }));
  },
  ManagersBySupplierListParser: (_res: unknown): ManagersBySupplierItem[] => {
    const items = _get(_res, 'data', []) as any[];
    if (!Array.isArray(items)) return [];

    return items.map((itm) => ({
      supplierId: _get(itm, 'supplierId', 0),
      supplierName: _get(itm, 'supplierName', ''),
      managerId: _get(itm, 'managerId', 0),
      managerName: _get(itm, 'managerName', ''),
      active: Boolean(_get(itm, 'active', false)),
    }));
  },
};

export default companiesSuppliersApiParser;

// --------------- Companies Suppliers-specific types and data ---------------

export interface CompaniesSuppliersItem {
  id: number;
  shortName: string;
  supplier: string;
  makers: string[];
  managers: string[];
  status: string;
}

export interface MakersBySupplierItem {
  supplierId: number;
  supplierName: string;
  makerId: number;
  makerName: string;
  active: boolean;
}

export interface ManagersBySupplierItem {
  supplierId: number;
  supplierName: string;
  managerId: number;
  managerName: string;
  active: boolean;
}

export interface CompaniesSuppliersData {
  companiesSuppliers: CompaniesSuppliersItem[];
  companies: { value: number | string; label: string }[];
  makers: { value: number | string; label: string }[];
  managers: { value: number | string; label: string }[];
  statusOptions: { value: string; label: string }[];
}
